import type {
  AttendanceHistoryExportRow,
  StudentAttendance,
} from '@court-sync/shared';
import {
  buildStudentBillingCsvRows,
  buildStudentBillingDrilldownCsvRows,
} from '@court-sync/shared';
import { format } from 'date-fns';

export { buildStudentBillingCsvRows, buildStudentBillingDrilldownCsvRows };

function sessionStatusLabel(a: StudentAttendance): string {
  if (a.sessionStatus) return a.sessionStatus;
  if (a.lessonsCancelled > 0) return 'cancelled';
  if (a.lessonsMissed > 0) return 'missed';
  if (a.lessonsAttended > 0) return 'attended';
  return 'scheduled';
}

function sortTimestamp(a: StudentAttendance): number {
  const raw = a.lessonDate ?? a.lastAttendedDate ?? a.updatedAt ?? a.createdAt;
  if (!raw) return 0;
  const t = new Date(raw).getTime();
  return Number.isNaN(t) ? 0 : t;
}

export function buildSingleStudentAttendanceCsvRows(
  rows: StudentAttendance[],
  lessonNameById?: Record<string, string>
): Record<string, string | number | boolean | undefined>[] {
  const sorted = [...rows].sort((a, b) => sortTimestamp(b) - sortTimestamp(a));
  return sorted.map((row) => ({
    date: row.lessonDate ? format(new Date(row.lessonDate), 'yyyy-MM-dd') : '',
    lessonName: lessonNameById?.[row.lessonId] ?? '',
    lessonId: row.lessonId,
    lessonPrice: row.lessonPrice,
    status: sessionStatusLabel(row),
    notes: row.notes?.trim() ?? '',
  }));
}

export function buildAcademyAttendanceCsvRows(
  rows: AttendanceHistoryExportRow[]
): Record<string, string | number | boolean | undefined>[] {
  return rows.map((r) => ({
    studentId: r.studentId,
    firstName: r.firstName,
    lastName: r.lastName,
    lessonName: r.lessonName,
    lessonId: r.lessonId,
    lessonType: r.lessonType,
    lessonPrice: r.lessonPrice,
    lessonDate: r.lessonDate,
    status: r.status,
    notes: r.notes,
  }));
}
